export const AWAY_MODE_CHANGE = 'AWAY_MODE_CHANGE';